import React from 'react';
import CellFactory from '../../CellFactory';

const EdexcelGCSE = ({ row }) => {
  const {
    year,
    paper1,
    paper1Ms,
    paper1WrittenMs,
    paper1PredictedList,
    paper2,
    paper2Ms,
    paper2WrittenMs,
    paper2PredictedList,
    paper3,
    paper3Ms,
    paper3WrittenMs,
    paper3PredictedList,
  } = row;

  return (
    <tr>
      <td>{year}</td>
      <td>
        <CellFactory cells={paper1} />
      </td>
      <td>
        <CellFactory cells={paper1Ms} />
      </td>
      <td>
        <CellFactory cells={paper1WrittenMs} />
      </td>
      <td>
        <CellFactory cells={paper1PredictedList} />
      </td>
      <td>
        <CellFactory cells={paper2} />
      </td>
      <td>
        <CellFactory cells={paper2Ms} />
      </td>
      <td>
        <CellFactory cells={paper2WrittenMs} />
      </td>
      <td>
        <CellFactory cells={paper2PredictedList} />
      </td>
      <td>
        <CellFactory cells={paper3} />
      </td>
      <td>
        <CellFactory cells={paper3Ms} />
      </td>
      <td>
        <CellFactory cells={paper3WrittenMs} />
      </td>
      <td>
        <CellFactory cells={paper3PredictedList} />
      </td>
    </tr>
  );
};

export default EdexcelGCSE;
